import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IconModel } from '../../models/icon-model';
import { IconService } from '../../services/icon.service';


@Component({
    selector: 'app-fa-icon-list',
    templateUrl: './fa-icon-list.component.html',
    styleUrls: ['./fa-icon-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FaIconListComponent implements OnInit {

  searchTerm: string = '';
  iconRows: IconModel[][] = [];
  visibleIconCount = 0;
  iconsLoading = false;
  iconLoadError = false;
  readonly iconsPerRow = 6;

  constructor(
    public iconService: IconService,
    public dialogRef: MatDialogRef<FaIconListComponent>,
    @Inject(MAT_DIALOG_DATA) public icon: IconModel) {

  }

  async ngOnInit(): Promise<void> {
    this.searchTerm = this.icon?.displayName ?? '';
    this.iconsLoading = true;
    this.iconLoadError = false;
    try {
      await this.iconService.loadIcons();
      this.updateFilteredIcons();
    } catch {
      this.iconLoadError = true;
      this.visibleIconCount = 0;
      this.iconRows = [];
    } finally {
      this.iconsLoading = false;
    }
  }

  select(icon: IconModel): void {
    this.dialogRef.close(icon);
  }

  close(): void {
    this.dialogRef.close();
  }

  onSearchTermChange(value: string): void {
    this.searchTerm = value || '';
    this.updateFilteredIcons();
  }

  trackByIconRow(index: number): string {
    return `${index}`;
  }

  trackByIcon(_index: number, icon: IconModel): string {
    return icon?.id || icon?.iconString || `${icon?.prefix}.${icon?.name}`;
  }

  private updateFilteredIcons(): void {
    const query = this.normalizeText(this.searchTerm);
    const filteredIcons = (this.iconService.list || [])
      .filter((icon): icon is IconModel => !!icon)
      .filter((icon) => {
        if (!query) {
          return true;
        }

        return [
          icon.displayName,
          icon.name,
          icon.prefix,
          icon.iconString
        ].some((value) => this.normalizeText(value).includes(query));
      });

    this.visibleIconCount = filteredIcons.length;
    this.iconRows = this.toRows(filteredIcons);
  }

  private toRows(icons: IconModel[]): IconModel[][] {
    const rows: IconModel[][] = [];
    for (let index = 0; index < icons.length; index += this.iconsPerRow) {
      rows.push(icons.slice(index, index + this.iconsPerRow));
    }
    return rows;
  }

  private normalizeText(value: string | null | undefined): string {
    return String(value || '').trim().toLocaleLowerCase();
  }
}
